import { useBehavior, useButton } from '@libs/hooks';
import { TTimerButtonData, TWidgetProps } from '@libs/types';
import React, { useMemo } from 'react';
import { TButtonOption } from '../../types/options';
import { ButtonRow } from './ButtonRow';
import { useInterval } from './hooks';
import { getSecondsToDate } from './utils/dateUtils';

export const ButtonRowTimer = ({ widget }: TWidgetProps<TTimerButtonData, TButtonOption>) => {
    const data = widget.data ?? {};
    const { handleClick } = useButton(widget);
    const { isHidden } = useBehavior(widget);

    const totalSeconds = useMemo(() => getSecondsToDate(data.endDate), [data.endDate]);

    const { time, timerEnd } = useInterval(1000, totalSeconds);

    const label = timerEnd ? data.messages?.label : `${data.messages?.timerTitle} ${time}`;

    return (
        <ButtonRow
            isWidget={false}
            isHide={isHidden}
            isDisabled={!timerEnd}
            as="button"
            label={label}
            iconName={data.iconName}
            uid={widget.uid}
            handleClick={() => handleClick()}
        />
    );
};
